export const VersionList = [
    {
        imageUrl: "/image/skills/aws.png",
        altTag: "Aws image",
        title: "AWS"
    },
    {
        imageUrl: "/image/skills/git.png",
        altTag: "git image",
        title: "Git"
    },
    {
        imageUrl: "/image/skills/github.png",
        altTag: "github image",
        title: "GitHub"
    },
    {
        imageUrl: "/image/skills/devops.png",
        altTag: "Azure DevOps image",
        title: "Azure DevOps"
    },

]